import React, { Component } from 'react'
import { translate } from "react-i18next"
import styled from 'styled-components'
import { ApiConfigContext } from '../../context/api-config'
import * as changeCase from "change-case";
import './PrivacyNotice.css'

class PrivacyNotice extends Component {

  static contextType = ApiConfigContext


  constructor(props){
    super(props)

    this.state = {
      display: false,
      showGdprContent: false,
    }

    this.toggle = this.toggle.bind(this)
    this.showGdprContent = this.showGdprContent.bind(this)
  }

  getThemeWrapper(){
    return styled.div`
      .font-primary-color { color: ${props => props.theme.main}; }
    `
  }

  toggle(e) {
    e.preventDefault()
    this.setState({
      display: !this.state.display
    })
    return false
  }

  showGdprContent() {
    this.setState({ showGdprContent: true })
  }

  privacyContent() {

    const {brand} = this.context;
    const brandName = changeCase.sentenceCase(brand);

    return (
      <div>
        <h4>Privacy Collection Notice</h4>
        <p>{brandName} International Pty Ltd and our users ('we', 'us' or 'our') collect your personal information in order to provide you with the {brandName} service and permit you to make booking requests with our users and for the purposes set out in our <button id="toggle-content" onClick={this.showGdprContent}>Privacy Policy</button>.</p>
        <p>Your information will be collected by or on behalf of us and may be disclosed to third parties that help us deliver our services (including information technology suppliers, communication suppliers and our business partners) or as required by law. If you do not provide this information, we may not be able to provide all our services or products to you. We may disclose your personal information to recipients that are located outside of Australia, including to software companies located in the USA.</p>
        <p>Our Privacy Policy sets out:</p>
        <ol>
          <li>how we store and use, and how you may access and correct your personal information;</li>
          <li>how you can complain about the handling of your personal information; and</li>
          <li> how we will handle any complaint.</li>
        </ol>
        <p>For further information please contact us at <a href={`mailto:privacy@${brand}.com`}>privacy@{brand}.com</a>. By providing your personal information to us, you consent to the collection, use, storage and disclosure of that information as described in the Privacy Policy and this collection notice.</p>
      </div>
    )
  }

  gdprContent() {

    const {brand} = this.context;
    const brandName = changeCase.sentenceCase(brand);

    return (
      <div className="gdpr-privacy">
        <h4>Privacy &amp; GDPR</h4>

        <h5>Preamble</h5>

        <h6>What is the GDPR?</h6>
        <section>
          <p>The European Union General Data Protection Regulation (GDPR) is a regulation that protects European citizens with a unifying set of privacy laws for all EU member states. Made effective in late May 2018, GDPR will not only mean architectural changes to how software providers like {brandName} treat your data, but also implements a slew of processes and ongoing audits to instill constant vigilance as custodians of user data.</p>
          <p>{brandName} cares about your data security and we are dedicated to compliance with GDPR.</p>
        </section>

        <h6>Aren’t you based in Australia? Why do you care?</h6>
        <section>
          <p>{brandName} is a proudly Australian company. However, we provide meeting scheduling and bookings globally, and we can’t control who signs up to our software and where. We already have many users from the EU and we want to ensure that they receive the protection established under GDPR, as we are bound to do.</p>
          <p>The GDPR makes a lot of practical and ethical sense, and is considered to be one of the most stringent privacy regulations. So by making sure we are compliant with GDPR we also tick the boxes of many other national regulations.</p>
        </section>

        <h6>How will I be affected?</h6>
        <section>
          <p>As of the entry into force of this privacy regulation, you will benefit from the GDPR system. Your rights are detailed below.</p>
          <p>If you collect customer data using {brandName}’s service, GDPR  may apply to you; be sure to inquire about the implications that this may have for you and your business.</p>
        </section>

        <h6>Good security practices</h6>
        <section>
          <p>We, at {brandName}, apply GDPR-compliant organizational and technical security policies and we would recommend you do as well.</p>
          <p>For example, all data is encrypted at rest using AWS and we use managed encryption keys to ensure that if the data is compromised it cannot be deciphered. {brandName} also uses HTTPS connections to ensure that we are always secure.</p>
          <p>If you are an individual user, we recommend you follow these security recommendations issued by the University of Berkeley:</p>
          <p><a href="https://security.berkeley.edu/resources/best-practices-how-to-articles/top-10-secure-computing-tips">https://security.berkeley.edu/resources/best-practices-how-to-articles/top-10-secure-computing-tips</a></p>
          <p>All employees of {brandName} have been made aware of the GDPR compliance practices, and have been provided an updated contract with GDPR statutes included. All future employees will receive such a contract by default. Our contractors are required to sign contracts to ensure that they apply the same level of security as us to your data. By implementing these actions we are ensuring that our staff do not engage in bad practices. Ongoing audits will also maintain these standards.</p>
        </section>

        <h6>Data collected by {brandName}</h6>
        <section>
          <p>{brandName} complies with all applicable data protection laws, and will not use your personal data for other purposes than those listed below.</p>
          <p>We collect <a href="https://iapp.org/media/pdf/resource_center/Categories-of-personal-information.pdf">limited external information from you.</a></p>
          <p>If you need to make specific GDPR enquiries, please get in touch via privacy+gdpr@{brandName}.com</p>
          <p>{brandName} only collects the data that it needs to provide you with its service. The data we collect is the following:</p>

          <h6>a) The data about you and your business</h6>
          <ul>
              <li><span>Your name</span></li>
              <li><span>Your email</span></li>
              <li><span>Your profile picture</span></li>
              <li><span>Your business name</span></li>
              <li><span>Your business operating addresses</span></li>
              <li><span>Your website address</span></li>
              <li><span>Your logo</span></li>
              <li><span>Your business hours</span></li>
              <li><span>The services you provide</span></li>
              <li><span>The price you charge for these services</span></li>
              <li><span>The duration of these services</span></li>
              <li><span>The currency you use</span></li>
              <li><span>Your timezone</span></li>
              <li><span>Details about the device you use to access our website and service</span></li>
              <li><span>place of employment</span></li>
              <li><span>occupation,</span></li>
              <li><span>telephone number(s)</span></li>
              <li><span>date of birth and gender;</span></li>
              <li><span>Your individual preferences in respect of the services we provide you;</span></li>
              <li><span>Demographic information – normalised through Google Analytics – you can opt out here <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a>;</span></li>
              <li><span>Details as to whether you have taken up any products or offerings we have made;</span></li>
              <li><span>Whether you have a connection with others whose personal information we may collect or hold such an employee in your {brandName} account;</span></li>
              <li><span>What, how and when you have dealt with us or expressed an interest in buying from us;</span></li>
              <li><span>Any stated preferences for our products or services you have provided to us;</span></li>
              <li><span>Custom information which our users set in a custom field in the {brandName} booking system and which you may be invited to complete as part of requesting a booking or other service.</span></li>
              <li><span>Mouse tracking and session recording – may used to track how you interact with our software</span></li>
            </ul>

          <h6>b) the data you provide about your customers</h6>
          <ul>
            <li><span>When you use our service, they may complete a customized form with data from participants to the scheduled events. We collect this data in order to schedule the event, and delete it immediately after.</span></li>
            <li><span>Our users may request Sensitive Information from you if those users fill in custom fields in a {brandName} booking page. Our Terms only permit our users to request this information if the information is necessary for their business. Your Sensitive Information may be stored on a central database encrypted.</span></li>
          </ul>

          <h6>c) information about your system</h6>
          <p>We also collect information from your computer automatically when you browse our Website. This information may include:</p>
          <ul>
            <li><span>the date and time of your visit;</span></li>
            <li><span>your domain;</span></li>
            <li><span>locality;</span></li>
            <li><span>operating system;</span></li>
            <li><span>the server your computer is using to access our Website;</span></li>
            <li><span>search terms you have entered to find our Website or enter on our Website;</span></li>
            <li><span>pages and links you have accessed both on our Website and on other websites;</span></li>
            <li><span>the pages of our Website you access; and</span></li>
            <li><span>your IP Address.</span></li>
          </ul>
          <p>Please note that it may be possible for us to identify you from information collected automatically from your visit(s) to our Website. If you have registered an account with us, we will able to identify you through your user name and password when you log into our website or any applications. Further, if you access our Website via links in an email we have sent you, we will be able to identify you.</p>
          <p>We may use statistical analytics software tools such as Google Analytics and software known as cookies which transmit data to third party servers located overseas including in the United States of America. To our knowledge Google Analytics does not identify individual users or associate your IP Address with any other data held by Google.</p>
          <ul>
            <li>– If you do not wish to grant us the right to use cookies to gather information about you while you are using our Website, then you may elect to set your browser settings to disable cookies. This may cause parts of our Website to not function properly.</li>
            <li>– Please note that our Website may contain links to other websites, and your use of those websites is not covered by this privacy policy. We encourage you to review each website’s privacy policy.</li>
          </ul>
        </section>

        <h6>Why we collect this data</h6>
        <section>
          <p>We need the data we collect for the following reasons:</p>
          <ul>
            <li>To deliver our products and services to you;</li>
            <li>To respond to individual and company requests;</li>
            <li>In connection with your attendance or participation in scheduled events</li>
            <li>To manage our relationship with you, evaluate our business performance and build our customer database;</li>
            <li>To provide you with relevant information about our products, services, functions, events or activities;</li>
            <li>To process transactions;</li>
            <li>To enable you to participate in promotions, competitions, surveys and / or enable you to subscribe to mailing lists/newsletters and interact or follow our social media pages, including Twitter, Facebook and Instagram;</li>
            <li>To ask for your feedback and to address any requests you may regarding our services;</li>
            <li>To conduct research, compile or analyse statistics relevant to the operations of our business;</li>
            <li>To facilitate our internal business operations, including fulfilment of any legal and regulatory requirements;</li>
            <li>To create backups of our business records;</li>
            <li>To maintain a customer database or similar record;</li>
            <li>For direct marketing purposes;</li>
            <li>To manage and optimize our Website. This helps us run our Website more efficiently and give you a better experience online. further improve your experience in using our Website;</li>
            <li>To enable our users to offer the {brandName} service to their customers or potential customers, including for making bookings and reservations</li>
          </ul>
          <p>If you choose not to provide us with the data we request, you may experience the following inconveniencies:</p>
          <ul>
            <li>You may not be eligible for latest offers</li>
            <li>You may not be able to upgrade or take advantage of latest plans and features</li>
            <li>You may have sections of the app locked away from you</li>
            <li>You may risk having your account not being backed up</li>
          </ul>
        </section>

        <h6>When we collect your data</h6>
        <section>
          <p>We collect data about you at the following events:</p>
          <ul>
            <li>When you contact us over the phone, email or chat;</li>
            <li>When we provide you with our services via telephone, our website or via {brandName};</li>
            <li>When we provide you with assistance or support for our products or services;</li>
            <li>When you participate in our functions, events, activities or social media pages;</li>
            <li>When you request that we provide you with information concerning our products or services; and</li>
            <li>You complete any forms requesting information from you, complete any survey or provide feedback to us concerning our products or services.</li>
            <li>Where practicable we will only collect information from you personally.</li>
          </ul>
        </section>

        <h6>How long we keep your data</h6>
        <section>
          <p>Form data is stored on AWS in a GDPR compliant fashion, and erased shortly after valid appointments have taken place.</p>
        </section>

        <h6>Exercising your GDPR rights</h6>
        <section>
          <p>If you wish to exercise your right to:</p>
          <ol>
            <li>Obtain a copy of your data</li>
            <li>Rectify your data</li>
            <li>Erase your data</li>
            <li>Restrict processing or your data</li>
            <li>Portability of your data</li>
            <li>Object to the processing of your data</li>
            <li>Limited automated decision making / profiling</li>
          </ol>
          <p>please contact <a href={`mailto:support+gdpr@${brand}.com`}>support+gdpr@{brand}.com</a> from the email address that is the owner of your {brandName} account, stating your requests clearly.</p>
          <p>If you wish to contact us in relation to personal data matters, please write to us – at your convenience on one of the following addresses:</p>
          <p><strong>Privacy Officer</strong></p>
          <p>{brandName} International Pty Ltd<br />C/- Piper Alderman Lawyers<br />Level 23, Governor Macquarie Tower<br />One Farrer Place, Sydney NSW 2000<br />AUSTRALIA</p>
          <p>or by email to <a href={`mailto:support+privacy@${brand}.com`}>support+privacy@{brand}.com</a></p>
          <p>You may also contact the supervisory authority of your place of residence.</p>
          <p>Third Party Service Providers and Data controllers</p>
        </section>

        <h6>Calendar security</h6>
        <section>
          <p>Our integration with Google and Office 365 calendar uses the secure OAuth 2.0 authentication protocol.</p>
          <p><a href="https://auth0.com/docs/compliance/gdpr">https://auth0.com/docs/compliance/gdpr</a></p>
        </section>

        <h6>Infrastructure security</h6>
        <section>
          <p>{brandName} is hosted on Amazon Web Services. We are constantly improving our architecture and security and may on occasion employ penetration testers to help ensure our systems are suitably secure.</p>
          <p>We use information from third party services such as Google Analytics to help</p>
          <p>For more information on how AWS keeps your data safe, you can <a href="https://aws.amazon.com/compliance/gdpr-center/">read their terms here.</a></p>
          <p>We also agree to only transfer your data outside of the European Union, where we have taken measures to ensure GDPR compliance within the areas where this information is being transferred.</p>
        </section>

        <h6>In case of a data breach</h6>
        <section>
          <p>Should you suspect any unlawful or otherwise unauthorized activity in relation to your {brandName} account, please email us immediately:</p>
          <p><a href={`mailto:support+breach@${brand}.com`}>support+breach@{brand}.com</a></p>
          <p>In the unlikely event that {brandName} or its third party affiliates suffers a data breach, we will notify the competent supervisory authority within 72 hours of becoming aware of it; we will also notify you in compliance with the GDPR rules.</p>
          <p>The information we provide to the Supervisory authority will be:</p>
          <ul>
            <li>
              <span>The type of personal data breach, including:</span>
              <ul>
                <li>The type and estimated number of individuals affected; and</li>
                <li>The type and estimated number of personal data records concerned.</li>
              </ul>
            </li>
            <li>The name and contact details of a point of contact where further information can be obtained, such as that of the data protection officer (DPO);</li>
            <li>The possible outcomes of the personal data breach; and</li>
            <li>A list of measures taken or being taken to deal with the breach and appropriate measures taken to mitigate any adverse effects.</li>
          </ul>
        </section>

        <h5>Further important information about {brandName}’s activity</h5>

        <h6>Target audience</h6>
        <section>
          <p>{brandName} is not a service intended for children, and is not meant to be used by children. We also do not show or trade any explicit content that would be objectionable to children should they stumble upon the site.</p>
        </section>

        <h6>No sensitive data collected</h6>
        <section>
          <p>{brandName} does not collect sensitive data by default as defined by articles 9 and 10 of the GDPR and we do not expect to receive any.</p>
          <p>You, as a {brandName} customer may use the custom form builder to collect data that is compliant with GDPR laws. {brandName} is HIPAA compliant, and does take extra steps to purge all custom form data collected 24 hours after a scheduled appointment has taken place.</p>
        </section>

        <h6>New features</h6>
        <section>
          <p>Everytime we create a feature or add functionality that is outside of the consent you provided us, we will prompt you to agree to the updated consent conditions; explicitly and in simple English.</p>
        </section>

        <h6>Data Transfers</h6>
        <section>
          <p>In compliance with GDPR, we only transfer your data to countries that have a level of protection of personal data equivalent to GDPR and approved by the European commission.</p>
        </section>

        <h6>Third Party affiliates who process data for {brandName}</h6>
        <section>
          <p>Below are list of the services that we use to run {brandName} and their respective locations. We ensure safe harbour between these providers.</p>
          <table>
            <thead>
              <tr>
                <th>Service</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Amazon Web Services</td>
                <td>United States of America</td>
              </tr>
              <tr>
                <td>Prisma</td>
                <td>Germany, United States of America</td>
              </tr>
              <tr>
                <td>Heroku</td>
                <td>United States of America</td>
              </tr>
              <tr>
                <td>Cloudflare</td>
                <td>United States of America</td>
              </tr>
              <tr>
                <td>Google</td>
                <td>United States of America</td>
              </tr>
              <tr>
                <td>Auth0</td>
                <td>United States of America</td>
              </tr>
              <tr>
                <td>Stripe</td>
                <td>Ireland, United States of America</td>
              </tr>
              <tr>
                <td>Hotjar</td>
                <td>Malta</td>
              </tr>
              <tr>
                <td>Mailgun</td>
                <td>United States of America</td>
              </tr>
              <tr>
                <td>Plivo</td>
                <td>United States of America</td>
              </tr>
              <tr>
                <td>Unbounce</td>
                <td>United States of America</td>
              </tr>
              <tr>
                <td>Netlify</td>
                <td>United States of America</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    )
  }

  render() {
    const ThemeWrapper = this.getThemeWrapper()

    if(!this.state.display) {
      return (
        <ThemeWrapper>
          <a className="privacy-notice-toggle font-primary-color" onClick={this.toggle} href="#privacy-notice"><i className="fa fa-info-circle" /></a>
        </ThemeWrapper>
      )
    }

    return (
      <div className="privacy-notice-screen">
        <div className="overlay" onClick={this.toggle}></div>
        <div className="notice">
          { this.state.showGdprContent ? this.gdprContent() : this.privacyContent() }
          <button id="close-modal" className="btn btn-primary" onClick={this.toggle}>Close</button>
        </div>
      </div>
    )
  }
}

export default translate("translations")(PrivacyNotice)
